module.exports = __webpack_public_path__ + "static/media/gb.9fd2b058.svg";